import { useNavigate } from 'react-router-dom';
import useInvoice from './hooks/useInvoice';
import TableHeaderComponent from '../../components/tableHeaderComponent';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setSelectedInputValue,
} from '../../../../store/action/advanceFilter';
import { getFiltersParams } from '../../../../helper';
import AdvanceFilterSelectInput from '../../../../component/Filter/AdvanceFilterSelectInput';
import advanceFilterIcon from '../../../../assets/image/advanceFilter.svg';
import clearAllFilter from '../../../../assets/image/clearAllFilter.svg';
import addFilter from '../../../../assets/image/AddFilter.svg';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import PageLoader from '../../../../component/PageLoader';
import Table from '../../../../component/table/Table';
import Pagination from '../../../../component/pagination';
import AdvanceFilter from '../../../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../../../component/Filter/advanceFilterOptions';
import { useState } from 'react';
import { ExportTable } from '../../../../store/action/export/Export';
import CustomAlertModel from '../../components/customAlertModel';
import { hasPermission } from '../../../../utils/controller';

const Invoice = () => {
	const {
		user,
		invoiceList,
		suburl,
		handlePageChange,
		onRowClick,
		handleDeselectAll,
		FilterDatalist,
		sortDataList,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		searchSelectedInputItems,
		setIsAdvanceFilterOpen,
		isAdvanceFilterOpen,
		isAdvanceFilterApplied,
		selectedInputs,
		setBulkAction,
		bulkAction,
		deselectRows,
		isLoading,
		isLoader,
		setHeaderDropDown,
		headerDropDown,
		dispatch,
		sortDirection,
		advanceFilterPage,
		advanceFilterTotalPages,
		invoiceParams,
		summaryDetails,
		handlePrintAndDownloadPdf,
		selectedInvoiceListForMarkAsSent,
		setIsMarkAsSentModalOpen,
		isMarkAsSentModalOpen,
		handleBulkMarkAsSent,
		handleOpenBulkInvoiceModal,
	} = useInvoice();
	const [isSortBy, setIsSortBy] = useState(false);
	const navigate = useNavigate();
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const exportTableData = (param) => {
		ExportTable(param);
	};

	const invoiceTableColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'date', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								DATE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.date]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'INVOICE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'invoice_number', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								INVOICE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.invoice_number]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'status', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								STATUS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.status]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 250,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'total_amount', sort_by: 'asc' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
									alignItems: 'center',
									color: 'black',
								}}
							>
								AMOUNT
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.total_amount]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'CREDIT APPLIED',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 200,

			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'credit_applied' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
									alignItems: 'center',
									color: 'black',
								}}
							>
								CREDIT APPLIED
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.credit_applied]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	return (
		<div
			style={{
				overflow: 'hidden',
			}}
		>
			<TableHeaderComponent
				bulkAction={bulkAction}
				createButton={{
					disabled: !hasPermission('sales.invoices.create', user?.role?.role_permissions),
					buttonName: 'Create New Invoice',
					handler: () => navigate(`/user/${suburl}/invoices-create`),
				}}
				closeButton={{
					showCloseButton: true,
					handler: () => {
						setBulkAction(false);
						setBulkAction([]);
						deselectRows && deselectRows();
					},
				}}
				buttons={[
					{
						id: 1,
						className: 'btn-gray',
						button: 'Mark As Sent',
						handler: () => {
							handleOpenBulkInvoiceModal();
						},
					},
					{
						id: 2,
						className: 'btn-gray',
						button: 'Download Pdf',
						handler: () => {
							handlePrintAndDownloadPdf('', 'download', true);
						},
					},

					{
						id: 3,
						className: 'btn-gray',
						button: 'Print',
						handler: () => {
							handlePrintAndDownloadPdf('', 'print', true);
						},
					},
				]}
				dropdownButton={
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Drafts')}
								>
									Drafts
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Approved')}
								>
									Approved
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Open')}
								>
									Open
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Mark As Sent')}
								>
									Mark as sent
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Unpaid')}
								>
									Unpaid
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Partially Paid')}
								>
									Partially Paid
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Paid')}
								>
									Paid
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Overdue')}
								>
									Overdue
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Void')}
								>
									Void
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Write Off')}
								>
									Write Off
								</a>
							</li>
						</ul>
					</div>
				}
				advanceFilterButton={
					isAdvanceFilterApplied ? (
						<div>
							<button
								onClick={() => {
									dispatch(clearAdvanceFilter());
									setHeaderDropDown('All Invoices');
								}}
								style={{
									background: 'transparent',
									color: '#FF0000',
									fontSize: '14px',
									cursor: 'pointer',
									fontWeight: '600',
									lineHeight: '24px',
								}}
							>
								<img
									src={clearAllFilter}
									alt=""
									style={{ width: '18px', height: '18px', marginRight: '8px' }}
								/>
								Clear All Filters
							</button>
						</div>
					) : (
						<button
							onClick={() => setIsAdvanceFilterOpen(true)}
							style={{
								color: '#2E63F6',
								background: 'transparent',
								fontSize: '14px',
								cursor: 'pointer',
								fontWeight: '600',
								lineHeight: '24px',
							}}
						>
							<img
								src={advanceFilterIcon}
								alt=""
								style={{ width: '18px', height: '18px', marginRight: '8px' }}
							/>
							Advanced Filters
						</button>
					)
				}
				moreButton={
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
							onClick={(e) => e.preventDefault()}
						>
							<img src={sortbydot} />
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser"
							style={{ minWidth: '240px' }}
						>
							<li style={{ cursor: 'pointer' }}>
								<a
									className="dropdown-item"
									style={{
										display: 'flex',
										alignItems: 'center',
										fontSize: '14px',
										fontWeight: 'bold',
										justifyContent: 'space-between',
									}}
									onClick={(e) => {
										e.stopPropagation();
										setIsSortBy(!isSortBy);
									}}
								>
									Sort By
									<span>{isSortBy ? '▼' : '▶'}</span>
								</a>
							</li>
							{isSortBy ? (
								<>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'created_at', sort_by: 'asc' })}
										>
											Create Time
											<span>{sortIconMap[sortDirection?.created_at]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'updated_at', sort_by: 'asc' })}
										>
											Last Modified Time
											<span>{sortIconMap[sortDirection?.updated_at]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'date', sort_by: 'asc' })}
										>
											Date
											<span>{sortIconMap[sortDirection?.date]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'invoice_number', sort_by: 'asc' })}
										>
											Invoice #<span>{sortIconMap[sortDirection?.invoice_number]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() =>
												sortDataList({ order_by: 'sales_order_number', sort_by: 'asc' })
											}
										>
											Sales Order Number
											<span>{sortIconMap[sortDirection?.sales_order_number]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'customer_name', sort_by: 'asc' })}
										>
											Customer Name
											<span>{sortIconMap[sortDirection?.customer_name]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'due_date', sort_by: 'asc' })}
										>
											Due Date
											<span>{sortIconMap[sortDirection?.due_date]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'total_amount', sort_by: 'asc' })}
										>
											Amount
											<span>{sortIconMap[sortDirection?.total_amount]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'due_amount', sort_by: 'asc' })}
										>
											Balance Due
											<span>{sortIconMap[sortDirection?.due_amount]}</span>
										</a>
									</li>
								</>
							) : (
								<>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => {}}
										>
											Import Invoices
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => {
												exportTableData('invoice');
											}}
										>
											Export Invoices
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'preferences', sort_by: 'asc' })}
										>
											Preferences
											<span>{sortIconMap[sortDirection?.preference]}</span>
										</a>
									</li>

									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() =>
												sortDataList({ order_by: 'manage_custom_fields', sort_by: 'asc' })
											}
										>
											Manage Custom Fields
											<span>{sortIconMap[sortDirection?.manage_custom_fields]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortDataList({ order_by: 'id', sort_by: 'asc' })}
										>
											Refresh
											<span>{sortIconMap[sortDirection?.id]}</span>
										</a>
									</li>
								</>
							)}
						</ul>
					</div>
				}
			/>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					gap: 10,
					padding: '0px 10px',
				}}
			>
				{isAdvanceFilterApplied && (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Invoices');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div style={{ marginBottom: '8px', cursor: 'pointer' }}>
							<img
								src={addFilter}
								alt="Apply Filter"
								onClick={() => setIsAdvanceFilterOpen(true)}
							/>
						</div>
					</div>
				)}
			</div>
			<div
				style={{
					position: 'sticky',
					top: 65,
					borderBottom: '1px solid #EEEFF3',
					height: '100px',
					padding: '20px 30px',
					width: '100%',
					gap: '10px',
				}}
				className="d-flex"
			>
				<div
					style={{ height: '68px', marginTop: '-12px' }}
					className="d-flex flex-column"
				>
					<div>
						<h4
							className="fw-bold"
							style={{ fontSize: '18px', fontWeight: '600' }}
						>
							Summary
						</h4>
					</div>
					<div>
						<p style={{ fontSize: '1.5rem', color: '#555B67' }}>Total Outstanding Receivables</p>
					</div>
					<div>
						<h4
							className="fw-bold"
							style={{ fontSize: '16px' }}
						>
							{`₹ ${Number(summaryDetails?.total_outstanding_receivables || 0).toFixed(2)}`}
						</h4>
					</div>
				</div>

				<div
					style={{
						height: '55px',
						marginTop: '10px',
						borderLeft: '1px solid #EEEFF3',
						padding: '0px 30px',
					}}
					className="d-flex flex-column "
				>
					<div>
						<p style={{ fontSize: '1.5rem', color: '#555B67' }}>Due Today</p>
					</div>
					<div>
						<h4
							className="fw-bold"
							style={{ fontSize: '16px' }}
						>
							{`₹ ${Number(summaryDetails?.due_today || 0).toFixed(2)}`}
						</h4>
					</div>
				</div>
				<div
					style={{
						height: '55px',
						marginTop: '10px',
						borderLeft: '1px solid #EEEFF3',
						padding: '0px 30px',
					}}
					className="d-flex flex-column "
				>
					<div>
						<p style={{ fontSize: '1.5rem', color: '#555B67' }}>OverDue Amount</p>
					</div>
					<div>
						<h4
							className="fw-bold"
							style={{ fontSize: '16px' }}
						>
							{`₹ ${Number(summaryDetails?.overdue_amount || 0).toFixed(2)}`}
						</h4>
					</div>
				</div>
			</div>
			<div>
				{isLoading ? (
					// <PageLoader />
					<div
						className="d-flex justify-content-center align-items-center"
						style={{ height: '55vh' }}
					>
						<span
							className="Page_loader"
							role="status"
							aria-hidden="true"
						></span>
					</div>
				) : (
					<div className="productTable-body">
						<Table
							row={invoiceList.data}
							coloum={invoiceTableColumn}
							className="productTable"
							onRowClick={onRowClick}
							bulkAction={bulkAction}
							action={setBulkAction}
							onDeselectAll={handleDeselectAll}
						/>
					</div>
				)}
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : invoiceParams.page}
					totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : invoiceList.totalPages}
					onChangePage={handlePageChange}
				/>
				{isAdvanceFilterOpen && (
					<AdvanceFilter
						modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
						isOpen={isAdvanceFilterOpen}
						advanceFilterOptions={advanceFilterOptions?.invoices}
						onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
						handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
						onClose={() => {
							setIsAdvanceFilterOpen(false);
						}}
						onApply={handleApplyFilters}
					/>
				)}
				{isMarkAsSentModalOpen && (
					<CustomAlertModel
						title={'Mark As Sent'}
						setIsAlertModelOpen={setIsMarkAsSentModalOpen}
						isAlertModelOpen={isMarkAsSentModalOpen}
						customText={'Are You sure you want to Mark As Sent '}
						objectSelectedList={selectedInvoiceListForMarkAsSent}
						objectLength={selectedInvoiceListForMarkAsSent.length}
						saleTypeName={'Invoice'}
						handleBulk={handleBulkMarkAsSent}
					/>
				)}
			</div>
		</div>
	);
};

export default Invoice;
